import React, { forwardRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../../../../common/Validations";

const PrintPurchaseOrder = forwardRef((props, ref) => {
  const appConfig = useSelector((state) => state?.app?.appConfig);
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(props?.data);
  }, [props]);

  const totals = (data?.items || []).reduce(
    (acc, item) => {
      acc.purchaseQuantity += Number(item.purchaseQuantity);
      acc.orderPriceUnit += Number(item.orderPriceUnit);
      acc.netValue += Number(item.netValue);
      acc.taxAmount += Number(item.taxAmount);
      return acc;
    },
    { purchaseQuantity: 0, orderPriceUnit: 0, netValue: 0, taxAmount: 0 },
  );

  return (
    <div ref={ref} className="m-4 flex flex-col min-h-screen relative">
      <div className="font-arial text-sm m-5">
        {/* Header with Logo */}
        <div className="row">
          <div className="flex justify-start items-start col-5">
            <img src={appConfig?.customerLogo1} alt="" className="headerLogo" />
          </div>
          <div className="flex justify-start items-start col-6">
            <h2 className="text-center uppercase my-1 fs-4 fw-bold">
              Purchase Order
            </h2>
          </div>
        </div>

        {/* Title */}

        {/* Purchase Order Details */}
        <div className="bg-gray-300 font-bold py-1 px-1 my-2.5">
          Purchase Order Details
        </div>
        <table className="w-full border-collapse mb-2.5">
          <tbody>
            <tr>
              <td className="border border-black p-1">
                <strong>Date:</strong> { formatDate(data.purchasingDocumentDate)}
              </td>
              <td className="border border-black p-1">
                <strong>Purchase Order No:</strong> {data.purchasingDocumentNr}
              </td>
            </tr>
            <tr>
              <td className="border border-black p-1" colSpan="3">
                <strong>Purchasing Document Type:</strong>{" "}
                {data.purchasingDocumentType}
              </td>
            </tr>
            <tr>
              <td className="border border-black p-1">
                <strong>Vendor:</strong> {data.vendorName} ({data.vendorCode})
              </td>
              <td className="border border-black p-1" colSpan="2">
                <strong>Company:</strong> {data.companyCodeDesc} (
                {data.companyCodeCode})
              </td>
            </tr>
            <tr>
              <td className="border border-black p-1" colSpan="3">
                <strong>Inco Terms:</strong> {data.incoTermsDesc}, Location:{" "}
                {data.incoTermsLocation}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Buyer & Vendor */}
        <div className="bg-gray-300 font-bold py-1 px-1 my-2.5">
          Buyer & Vendor
        </div>
        <table className="w-full border-collapse mb-2.5">
          <thead>
            <tr>
              <th className="border border-black p-1 text-left bg-gray-100">
                Buyer (Bill To)
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Vendor
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-black p-1">
                {data.companyCodeDesc}
                <br />
                Address: {data?.addressDl || data?.AddressDl }
                <br />
                Mobile Number: {data?.mobileNoDl}
                <br />
                GST: {data?.gstInDl}
                <br />
                Email: {data?.emailDl}
                <br />
                {/* Payment Terms: {data?.paymentTerms} */}
              </td>
              <td className="border border-black p-1">
                {data?.vendorName}
                <br />
                Address:{data?.vendorAddress}
                <br />
                Vendor Code: {data?.vendorCode}
                <br />
                Mobile Number: {data?.vendorMobileNo}
                <br />
                GST: {data?.vendorGSTNo}
                <br />
                Email: {data?.vendorEmail}
                <br />
                {/* Payment Terms: {data?.paymentTerms} */}
                <br />
              </td>
            </tr>
          </tbody>
        </table>

        {/* Line Items */}
        <div className="bg-gray-300 font-bold py-1 px-1 my-2.5">Line Items</div>
        <table className="w-full border-collapse mb-2.5">
          <thead>
            <tr>
              <th className="border border-black p-1 text-left bg-gray-100">
                S.No
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Material Code
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Description
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Quantity
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Unit
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Unit Price
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Net Value
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Tax Amount
              </th>
              <th className="border border-black p-1 text-left bg-gray-100">
                Delivery Date
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.items &&
              data?.items.map((item, idx) => (
                <tr key={idx}>
                  <td className="border border-black p-1">{idx + 1}</td>
                  <td className="border border-black p-1">
                    {item.materialCode}
                  </td>
                  <td className="border border-black p-1">
                    {item.materialDescription}
                  </td>
                  <td className="border border-black p-1">
                    {item.purchaseQuantity}
                  </td>
                  <td className="border border-black p-1">
                    {item.orderUnitOfMeasure}
                  </td>
                  <td className="border border-black p-1 text-right">
                    {item.orderPriceUnit}
                  </td>
                  <td className="border border-black p-1 text-right">
                    {item.netValue}
                  </td>
                  <td className="border border-black p-1 text-right">
                    {item.taxAmount}
                  </td>
                  <td className="border border-black p-1">
                    {formatDate(item.deliveryDate)}
                  </td>
                </tr>
              ))}
          </tbody>
          <tfoot>
            <tr>
              <td className="border border-black p-1 text-right" colSpan="6">
                <strong>Total</strong>
              </td>
              <td className="border border-black p-1 text-right">
                {totals.netValue}
              </td>
              <td className="border border-black p-1 text-right">
                {totals.taxAmount}
              </td>
              <td className="border border-black p-1"></td>
            </tr>
          </tfoot>
        </table>

        {/* Summary */}
        <div className="bg-gray-300 font-bold py-1 px-1 my-2.5">Summary</div>
        <table className="w-full border-collapse mb-2.5">
          <tbody>
            <tr>
              <td className="border border-black p-1">
                <strong>Total Item Value:</strong> ₹{totals.netValue}
              </td>
              <td className="border border-black p-1">
                <strong>Total Tax:</strong> ₹{totals.taxAmount}
              </td>
              <td className="border border-black p-1">
                <strong>Grand Total:</strong> ₹
                {totals.taxAmount + totals.netValue}
              </td>
            </tr>
          </tbody>
        </table>

        {/* Remarks */}
        <div className="bg-gray-300 font-bold py-1 px-1 my-2.5">Remarks</div>
        <p>{data.purchasingRemark}</p>

        

        {/* Authorized Signatory */}
        <div className="text-right mt-7 mb-12">
          <p>
            For <strong>{/* {data.vendorName} */} Medirent Services Pvt Ltd</strong>
          </p>
          {/* <p className="mt-8">Authorised Signatory</p> */}
        </div>
      </div>

      {/* Footer at absolute bottom */}
      <p className="absolute bottom-0 left-0 right-0 text-center py-2.5 text-xs m-0 p-0">
        It is computer generated purchase order.
      </p>
    </div>
  );
});

export default PrintPurchaseOrder;
